"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from "react";
import type { CategoryOption, FilterGroup } from "./directory-listing.types";
export interface FilterChip {
  groupKey: string;
  id: string;
  name: string | null;
}
interface UseFilterChipsOptions {
  categoryOptions: CategoryOption[];
  selectedCategories: Set<string>;
  filterGroups: FilterGroup[];
  selectedFilters: Record<string, Set<string>>;
  dateFrom?: string | null;
  dateTo?: string | null;
  hasDateFilter?: boolean;
  onCategoryRemove: (id: string) => void;
  onFilterRemove: (groupKey: string, optionId: string) => void;
  onDateRangeChange?: (from: string | null, to: string | null) => void;
}
export function useFilterChips(t0) {
  const $ = _c(17);
  const {
    categoryOptions,
    selectedCategories,
    filterGroups,
    selectedFilters,
    dateFrom,
    dateTo,
    hasDateFilter,
    onCategoryRemove,
    onFilterRemove,
    onDateRangeChange
  } = t0;
  let result;
  if ($[0] !== categoryOptions || $[1] !== dateFrom || $[2] !== dateTo || $[3] !== filterGroups || $[4] !== hasDateFilter || $[5] !== selectedCategories || $[6] !== selectedFilters) {
    result = [];
    for (const cat of categoryOptions) {
      if (selectedCategories.has(cat._id)) {
        result.push({
          groupKey: "category",
          id: cat._id,
          name: cat.name
        });
      }
    }
    for (const group of filterGroups) {
      const selected = selectedFilters[group.key];
      if (!selected) {
        continue;
      }
      for (const option of group.options) {
        if (selected.has(option._id)) {
          result.push({
            groupKey: group.key,
            id: option._id,
            name: option.name
          });
        }
      }
    }
    if (hasDateFilter && (dateFrom || dateTo)) {
      const t1 = `${dateFrom ?? "..."} → ${dateTo ?? "..."}`;
      let t2;
      if ($[8] !== t1) {
        t2 = {
          groupKey: "dateRange",
          id: "dateRange",
          name: t1
        };
        $[8] = t1;
        $[9] = t2;
      } else {
        t2 = $[9];
      }
      result.push(t2);
    }
    $[0] = categoryOptions;
    $[1] = dateFrom;
    $[2] = dateTo;
    $[3] = filterGroups;
    $[4] = hasDateFilter;
    $[5] = selectedCategories;
    $[6] = selectedFilters;
    $[7] = result;
  } else {
    result = $[7];
  }
  const chips = result;
  let t1;
  if ($[10] !== onCategoryRemove || $[11] !== onDateRangeChange || $[12] !== onFilterRemove) {
    t1 = chip => {
      if (chip.groupKey === "category") {
        onCategoryRemove(chip.id);
      } else {
        if (chip.groupKey === "dateRange") {
          onDateRangeChange?.(null, null);
        } else {
          onFilterRemove(chip.groupKey, chip.id);
        }
      }
    };
    $[10] = onCategoryRemove;
    $[11] = onDateRangeChange;
    $[12] = onFilterRemove;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  const handleChipRemove = t1;
  let t2;
  if ($[14] !== chips || $[15] !== handleChipRemove) {
    t2 = {
      chips,
      handleChipRemove
    };
    $[14] = chips;
    $[15] = handleChipRemove;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  return t2;
}